import { isPlatformBrowser } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    PLATFORM_ID,
} from "@angular/core";
import {
    ButtonV3KindDirective,
    ButtonV3PaletteDirective,
    ButtonV3SizeDirective,
} from "@Front-end/ui/modules/button-v3";
import { LocalizeRouterModule } from "@gilsdav/ngx-translate-router";
import { TranslateModule } from "@ngx-translate/core";
import { StorageKeys } from "../../../../constants/storage.constants";

@Component({
    selector: "ls-cookies",
    templateUrl: "./cookies.component.html",
    styleUrls: ["./cookies.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TranslateModule,
        LocalizeRouterModule,
        ButtonV3KindDirective,
        ButtonV3PaletteDirective,
        ButtonV3SizeDirective,
    ],
})
export class CookiesComponent {

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    }

    public showCookiesMessage: boolean = isPlatformBrowser(this.platformId) ? !localStorage.getItem(StorageKeys.lsCookies) : false;
    public readonly cookiesMessage: string = "common.cookies-info";

    public acceptCookies(): void {
        isPlatformBrowser(this.platformId) && localStorage.setItem(StorageKeys.lsCookies, String(true));
        this.showCookiesMessage = false;
    }
}
